import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enUS from './en-US'
import zhCN from './zh-CN'

const resources = {
  en: { common: enUS },
  zh: { common: zhCN },
}

i18n
  .use(initReactI18next)
  .init({
    lng: 'en',
    resources,
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    supportedLngs: ['en', 'zh'],
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    keySeparator: '.',
    nsSeparator: false,
    initImmediate: false,
    react: { useSuspense: false },
  })

export default i18n
